import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { usePackage } from "../../hooks/usePackage";
import {
  resetOptionsData,
  resetTourState,
  setPackageData,
  setPrePackageData,
} from "../../reducer/tourReducer";
import { resetActiveTabs } from "../../reducer/sideBarSlice";
import { ReviewProductAvailibility } from "../../components/availability/ReviewProductAvailibility";

export default function WelcomeHeroSection() {
  const navigate = useNavigate();
  const account = useSelector((state: RootState) => state.account);
  const firstName = account?.account?.firstName || "Guest";
  const { getPrePackage, getPackageById } = usePackage();
  const [loading, setLoading] = useState<boolean>(false);
  const [prePackages, setPrePackages] = useState<any[]>([]);
  const dispatch = useDispatch();

  const handleCreate = () => {
    dispatch(resetTourState());
    dispatch(resetActiveTabs());
    dispatch(resetOptionsData());
    localStorage.removeItem("packageData");
    navigate(Paths.tourManagementCreate);
  };

  useEffect(() => {
    const getPrePackagedata = async () => {
      setLoading(true);
      const res = await getPrePackage({ setLoading });
      // console.log('prepackage', res)
      const filterPrePackage = res?.prePackages?.filter(
        (pkg: any) => pkg.progress < 20
      );
      setPrePackages(filterPrePackage || []);
      setLoading(false);
    };
    getPrePackagedata();
  }, []);

  const filterValidKeysDeep: any = (data: any) => {
    if (Array.isArray(data)) {
      return data.map((item) => filterValidKeysDeep(item));
    } else if (typeof data === "object" && data !== null) {
      return Object.fromEntries(
        Object.entries(data)
          .filter(
            ([_, value]) => value !== null && value !== undefined && value !== 0
          )
          .map(([key, value]) => [key, filterValidKeysDeep(value)])
      );
    }
    return data;
  };

  // todo: here check both the prepackages and preoptions progress and use the higher one to navigate
  const onResume = async (id: string) => {
    try {
      console.log("Resuming package with ID:", id); // Debugging log
      const response = await getPackageById({ setLoading }, id);

      if (response.success) {
        console.log("API response:", response); // Debugging log

        const filteredPackageData = Array.isArray(response.packageresponse)
          ? response.packageresponse.map(filterValidKeysDeep)
          : filterValidKeysDeep(response.packageresponse);

        dispatch(resetTourState());
        dispatch(setPrePackageData(id));
        dispatch(setPackageData(filteredPackageData));

        const progress = response.packageresponse?.progress || 0;
        console.log("Package progress:", progress); // Debugging log

        // Navigate based on progress
        if (progress < 1) {
          navigate(Paths.tourManagementCreate);
        } else if (progress < 2) {
          navigate(Paths.tourManagementPackageName);
        } else if (progress < 3) {
          navigate(Paths.tourManagementPackageDescription);
        } else if (progress < 4) {
          navigate(Paths.tourManagementPackageLocation);
        } else if (progress < 5) {
          navigate(Paths.tourManagementPackageKeywords);
        } else if (progress < 6) {
          navigate(Paths.tourManagementPackageInclusion);
        } else if (progress < 7) {
          navigate(Paths.tourManagementPackageGuideInfo);
        } else if (progress < 8) {
          navigate(Paths.tourManagementPackageFood);
        } else if (progress < 9) {
          navigate(Paths.tourManagementPackageTransportation);
        } else if (progress < 10) {
          navigate(Paths.tourManagementPackageExtraInfo);
        } else if (progress < 11) {
          navigate(Paths.tourManagementPackagePhotoUpload);
        } else if (progress < 12) {
          navigate(Paths.tourManagementPackageOptionsSetup);
        } else if (progress < 13) {
          navigate(Paths.tourManagementPackageOptionsMeeting);
        } else if (progress < 14) {
          navigate(Paths.tourManagementPackageOptionsConnectivity);
        } else if (progress < 15) {
          navigate(Paths.tourManagementPackageOptionsAvailability);
        } else if (progress < 16) {
          navigate(Paths.tourManagementPackageOptionsAvailabilitySchedule);
        } else if (progress < 17) {
          navigate(Paths.tourManagementPackageOptionsAvailabilityPriceCategory);
        } else if (progress < 18) {
          navigate(Paths.tourManagementPackageOptionsAvailabilityCapacity);
        } else if (progress < 19) {
          navigate(Paths.tourManagementPackageOptionsAvailabilityPrice);
        } else if (progress < 20) {
          navigate(Paths.tourManagementPackageOptionsCancelationPolicy);
        } else if (progress === 20) {
          navigate(Paths.welcome);
        } else {
          console.error("Unexpected progress value:", progress); // Debugging log
        }
      } else {
        console.error("API response indicates failure:", response); // Debugging log
      }
    } catch (error) {
      console.error("Error in onResume:", error); // Debugging log
    }
  };

  return (
    <div className={Classname.container}>
      <div className={Classname.topSection}>
        <div className={Classname.nameContainer}>
          <div className={Classname.textMain}>Welcome, {firstName}</div>
          <div className="text-sm lg:text-base">
            Create your first product and share unforgettable experiences with
            millions of travelers
          </div>
          <button className={Classname.button} onClick={handleCreate}>
            Create Product
          </button>
        </div>
        <div className={Classname.imageContainer}>
          <img src="/limitedSlots.png" alt="limited slots" />
          <img
            src="/bookingIncrease.png"
            className="mt-4 lg:ml-10"
            alt="booking increase"
          />
        </div>
      </div>

      {/* Dynamic Progress Section */}
      <div className="bg-white p-4 lg:p-6 rounded-lg shadow-md my-7">
        <h2 className="text-lg font-semibold mb-4">
          Finish creating your products
        </h2>
        {loading ? (
          <div className="text-center">Loading...</div>
        ) : prePackages.length > 0 ? (
          <div className="space-y-4">
            {prePackages.map((pkg) => (
              <div
                key={pkg._id}
                className="p-4 border border-gray-300 rounded-lg"
              >
                <h3 className="font-semibold">
                  {pkg.title || "Untitled Package"}
                </h3>
                <p className="text-gray-500 text-sm">
                  Started on {new Date(pkg.createdAt).toDateString()}
                </p>
                <div className="flex flex-col lg:flex-row justify-between mt-2 gap-4">
                  <div className="flex items-center w-full lg:w-auto">
                    <div className="w-full lg:w-96 h-3 bg-gray-300 rounded-full overflow-hidden">
                      <div
                        className="bg-green-500 h-full"
                        style={{ width: `${(pkg.progress / 20) * 100}%` }}
                      ></div>
                    </div>
                    <span className="ml-4 text-gray-700 font-semibold">
                      {Math.round((pkg.progress / 20) * 100)}%
                    </span>
                  </div>
                  <button
                    className="text-blue-500 font-semibold"
                    onClick={() => onResume(pkg._id)}
                  >
                    Resume
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center">No packages available.</div>
        )}
      </div>

      <ReviewProductAvailibility />
    </div>
  );
}

const Classname = {
  container: "w-full flex flex-col max-w-7xl mt-16 ",
  topSection: "bg-white rounded-lg flex ",
  nameContainer: "flex flex-col gap-3 justify-center lg:w-1/2 p-4 lg:p-6",
  imageContainer: "lg:block hidden",
  button:
    "bg-primary text-sm lg:text-base font-bold text-white rounded-lg px-4 lg:px-6 py-2 pb-3 w-fit",
  textMain: "font-bold text-lg",
};
